<!-- Toast notification container -->
<p-toast />

<!-- Actions Summary Dialog -->
<app-actions-summary-dialog
  [(visible)]="showActionsSummaryDialog"
  [data]="actionsSummaryData()"
  [infoMessage]="config().addressSyncMessage ?? null"
  (dismissed)="closeActionsSummary()" />

<!-- Dispatch Actions Dialog -->
<p-dialog
  [visible]="visible() && (!config().isNewDispatch || !!config().requireConfirmation)"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '800px'}"
  styleClass="dispatch-actions-dialog">
  
  <div class="dialog-content">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Dispatch Actions</h2>
      <button 
        type="button" 
        class="close-btn"
        (click)="onClose()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    
    <!-- Claim/Appointment Info -->
    <div class="info-section">
      <div class="info-group">
        <p class="info-text">
          <span class="info-label">Claim:</span>
          <span class="info-value">{{ config().claimNumber }}-{{ config().claimSequence }}</span>
        </p>
        <p class="info-text">
          <span class="info-label">Unit:</span>
          <span class="info-value">{{ formattedUnit() }}</span>
        </p>
      </div>
      <div class="info-group">
        <p class="info-text">
          <span class="info-label">Appraiser:</span>
          <span class="info-value">{{ config().appraiser }}</span>
        </p>
        <p class="info-text">
          <span class="info-label">Location:</span>
          <span class="info-value">{{ config().location }}</span>
        </p>
      </div>
    </div>
    
    <!-- Actions Grid -->
    <div class="actions-grid">
      @for (action of visibleDispatchActions(); track action.id) {
        <div class="action-item" 
             [class.selected]="action.checked"
             [class.disabled]="action.disabled"
             [class.full-width]="action.id === 'transmitCarPics' || action.id === 'transmitAutoVendor'">
          <div class="action-main">
            <p-checkbox 
              [(ngModel)]="action.checked"
              [binary]="true"
              [disabled]="action.disabled"
              (ngModelChange)="onActionChange(action)">
            </p-checkbox>
            <div class="action-text">
              <div class="action-label">
                {{ action.label }}
                @if (action.hasInfoIcon) {
                  <i class="pi pi-info-circle info-icon" 
                     pTooltip="Service includes pick-up of damaged vehicles, deliver and return of of a rental vehicle, and drop-off repaired vehicle."
                     tooltipPosition="top"></i>
                }
              </div>
              <div class="action-status">{{ action.status }}</div>
            </div>
          </div>
          
          <!-- Form for CarPics/HomePics -->
          @if (action.id === 'transmitCarPics' && action.hasForm) {
            <div class="action-form">
              <div class="form-fields-row">
                <div class="form-field">
                  <label class="form-label">Type</label>
                  <p-select
                    [formControl]="$any(carPicsForm.controls['requestType'])"
                    [options]="requestTypeOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select type"
                    appendTo="body"
                    styleClass="form-select">
                  </p-select>
                </div>
                <div class="form-field">
                  <label class="form-label">Cell Phone</label>
                  <p-inputMask
                    mask="999-999-9999"
                    [unmask]="true"
                    [autoClear]="false"
                    [formControl]="$any(carPicsForm.controls['cellPhone'])"
                    [style]="{ width: '100%' }"
                    styleClass="form-input" />
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    
    <!-- Footer Buttons -->
     @if (!config().isNewDispatch || config().requireConfirmation) {
    <div class="dialog-footer">
      <p-button
        label="Cancel"
        (onClick)="onClose()"
        [outlined]="true"
        styleClass="cancel-btn" />
      
        <p-button
          label="Submit"
          (onClick)="onSubmit()"
          [loading]="isSubmitting()"
          styleClass="submit-btn" />    
    </div>
      }
  </div>
</p-dialog>
